import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { isEmpty, isArray, isNull } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Input, DateTime } from '~/components/Form';
import { t } from '~/helpers';
import dateTime from '~/hooks/DateTime';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close }) {
  const [initials, setInitials] = useState({});
  const [server, setServer] = useState(null);

  const { client, id } = useSelector((state) => state.user.profile);

  async function handleSubmit(param) {
    const objSend = {
      idalteracaoestoqueproduto: 0,
      idposto: data.idposto,
      idcliente: client,
      idproduto: data.idproduto,
      idusuario: id,
      datahoraalteracaoestoqueproduto: param.datahoraalteracaoestoqueproduto
        ? param.datahoraalteracaoestoqueproduto
        : moment().format('DD/MM/YYYY HH:mm:ss'),
      valorantesalteracaoestoqueproduto: 0,
      valordepoisalteracaoestoqueproduto:
        param.valordepoisalteracaoestoqueproduto,
    };

    try {
      await api.post('alteracoesestoquesprodutos', objSend);
      await data.read();

      toast.success(t('s.geral.sucessoalteracao'));
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      } else {
        toast.error(t('s.geral.erroalteracao'));
      }
    } finally {
      await close();
    }
  }

  useEffect(() => {
    async function handleGetDate() {
      const date = await dateTime();
      await setServer(date);
    }

    handleGetDate();
  }, []);

  useEffect(() => {
    if (!isNull(server)) {
      setInitials({
        nomeproduto: data.nomeproduto,
        datahoraalteracaoestoqueproduto: server.format('DD/MM/YYYY HH:mm:ss'),
        valordepoisalteracaoestoqueproduto: 0,
      });
    }
  }, [server]);

  return (
    <>
      {!isEmpty(initials) && !isNull(server) && (
        <ContainerForm
          ref={reference}
          onSubmit={handleSubmit}
          initialData={initials}
        >
          <Input
            name="nomeproduto"
            label={t('s.configuracao.produto.nomeproduto')}
            disabled
          />

          <DateTime
            time
            name="datahoraalteracaoestoqueproduto"
            label={t('s.operacao.estoqueproduto.dataalteracao')}
          />

          <Input
            name="valordepoisalteracaoestoqueproduto"
            label={t('s.operacao.estoqueproduto.saldo')}
            type="number"
            min={0}
          />
        </ContainerForm>
      )}
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
